import React from 'react';
import { Template1, Template2, Template3, Template4, Template5, Template6, Template7 } from '../userTemplates/UserTemplates';

const EmailTemplatePreview = ({ selectedTemplate, data, customContent }) => {
  switch (selectedTemplate) {
    case 'template1':
      return <Template1 users={data.users} organizations={data.organizations} subscribers={data.subscribers} customContent={customContent} />;
    case 'template2':
      return <Template2 openCalls={data.open_calls} reviews={data.reviews} customContent={customContent} />;
    case 'template3':
      return <Template3 openCalls={data.open_calls} customContent={customContent} />;
    case 'template4':
      return <Template4 openCalls={data.open_calls} customContent={customContent} />;
    case 'template5':
      return <Template5 openCalls={data.open_calls} customContent={customContent} />;
    case 'template6':
      return <Template6 openCalls={data.open_calls} customContent={customContent} />;
    case 'template7':
        return <Template7 artistOfTheMonth={data.artist_of_month} customContent={customContent} />;
    default:
      return <p>Please select a template to preview.</p>;
  }
};

export default EmailTemplatePreview;
